export interface DocumentSerializerOutput {
  id: number
  title: string
  description: string
  slug?: string
}

interface Document {
  id: number
  title: string
  description: string
  slug?: string
}

export function DocumentSerializer(
  document: Document,
): DocumentSerializerOutput {
  return {
    id: document.id,
    title: document.title,
    description: document.description,
    ...(document.slug && { slug: document.slug }),
  }
}

export function FaqSerializer(faq: Document): DocumentSerializerOutput {
  return {
    id: faq.id,
    title: faq.title,
    description: faq.description,
    slug: faq.slug,
  }
}
